import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Tabs, TabsList, TabsTrigger } from "./ui/tabs";
import { Skeleton } from "./ui/skeleton";
import { ArrowUpRight, RefreshCw, Newspaper } from "lucide-react";

const ago = (iso) => {
  if (!iso) return "";
  const m = Math.max(1, Math.round((Date.now() - new Date(iso)) / 60000));
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
};

const Thumb = ({ src, size }) => {
  const [bad, setBad] = useState(false);
  if (!src || bad) return <Newspaper size={size} />;
  return <img src={src} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setBad(true)} />;
};

const NewsSection = () => {
  const [cat, setCat] = useState("crypto");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const load = async (c, force = false) => {
    if (data[c] && !force) return;
    setLoading(true); setError(false);
    try {
      const { data: res } = await api.get(`/news`, { params: { category: c, limit: 9 } });
      setData((d) => ({ ...d, [c]: res.items }));
    } catch { setError(true); }
    setLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(cat); }, [cat]);

  const items = data[cat] || [];
  const [lead, ...rest] = items;

  return (
    <section className="news" id="news" data-testid="news-section">
      <div className="news-inner">
        <div className="news-head">
          <div>
            <div className="section-eye left">Market News</div>
            <h2 className="section-h left">Know What Moves<br /><em>The Market.</em></h2>
          </div>
          <div className="news-ctrls">
            <Tabs value={cat} onValueChange={setCat}>
              <TabsList className="news-tabs">
                <TabsTrigger value="crypto" className="news-tab" data-testid="news-tab-crypto">Crypto</TabsTrigger>
                <TabsTrigger value="forex" className="news-tab" data-testid="news-tab-forex">Forex</TabsTrigger>
              </TabsList>
            </Tabs>
            <button className="news-refresh" onClick={() => load(cat, true)} aria-label="Refresh news" data-testid="news-refresh">
              <RefreshCw size={13} className={loading ? "spin" : ""} />
            </button>
          </div>
        </div>

        {loading && !items.length ? (
          <div className="news-grid">
            <Skeleton className="news-skel lead-skel" />
            {[0, 1, 2, 3].map((i) => <Skeleton key={i} className="news-skel" />)}
          </div>
        ) : error && !items.length ? (
          <div className="news-empty">Couldn't load headlines right now. <button onClick={() => load(cat, true)}>Try again</button></div>
        ) : !items.length ? (
          <div className="news-empty">No headlines available.</div>
        ) : (
          <div className="news-grid" data-testid="news-grid">
            <a className="news-card lead" href={lead.link} target="_blank" rel="noreferrer" data-testid="news-lead">
              <div className="news-img">
                <Thumb src={lead.image} size={40} />
              </div>
              <div className="news-body">
                <div className="news-meta"><span>{lead.source}</span>{ago(lead.published)}</div>
                <h3>{lead.title}</h3>
                {lead.summary && <p>{lead.summary}</p>}
                <span className="news-read">Read story <ArrowUpRight size={12} /></span>
              </div>
            </a>
            <div className="news-list">
              {rest.slice(0, 6).map((n) => (
                <a className="news-card row" key={n.link} href={n.link} target="_blank" rel="noreferrer" data-testid="news-item">
                  <div className="news-thumb"><Thumb src={n.image} size={18} /></div>
                  <div>
                    <div className="news-meta"><span>{n.source}</span>{ago(n.published)}</div>
                    <h4>{n.title}</h4>
                  </div>
                  <ArrowUpRight size={14} className="news-arrow" />
                </a>
              ))}
            </div>
          </div>
        )}
        <div className="news-foot">Headlines from CoinDesk, Cointelegraph, Investing.com &amp; ActionForex · updated every 10 minutes</div>
      </div>
    </section>
  );
};

export default NewsSection;
